import type { RsChartColors } from "./rsChartColors";

export interface MarkerPaletteEntry {
  chartColor: keyof RsChartColors;
  swatchClassName: string;
}

export const MARKER_PALETTE: MarkerPaletteEntry[] = [
  { chartColor: "offWhite", swatchClassName: "bg-rs-off-white" },
  { chartColor: "salmon", swatchClassName: "bg-rs-salmon" },
  { chartColor: "lightGray", swatchClassName: "bg-rs-light-gray" },
  { chartColor: "jetLight", swatchClassName: "bg-rs-jet-light" },
];

export function markerPaletteEntry(paletteIndex: number): MarkerPaletteEntry {
  return MARKER_PALETTE[paletteIndex % MARKER_PALETTE.length];
}
